import { FC, memo } from 'react';
import { Button, DatePicker, Form, Input, Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Dayjs } from 'dayjs';
import {
  INVOICE_PAYMENT_METHOD_OPTIONS,
  INVOICE_STATUS_OPTIONS
} from 'constants/invoicing';
import { InvoiceListFilters } from 'types/api/invoicing';

const { RangePicker } = DatePicker;

type FormValues = {
  search?: string;
  status?: InvoiceListFilters['status'];
  paymentMethod?: InvoiceListFilters['paymentMethod'];
  dateRange?: [Dayjs, Dayjs] | null;
};

interface IProps {
  onSubmit: (filters: InvoiceListFilters) => void;
}

const Filters: FC<IProps> = ({ onSubmit }) => {
  const [form] = Form.useForm<FormValues>();

  const onFinish = (values: FormValues) => {
    const [from, to] = values.dateRange ?? [];

    onSubmit({
      search: values.search?.trim() || undefined,
      status: values.status,
      paymentMethod: values.paymentMethod,
      from: from ? from.startOf('day').toISOString() : undefined,
      to: to ? to.endOf('day').toISOString() : undefined
    });
  };

  const onReset = () => {
    form.resetFields();
    onSubmit({});
  };

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onFinish}
      style={{ rowGap: 12, marginBottom: 16 }}
    >
      <Form.Item name="search">
        <Input
          allowClear
          placeholder="Patient or invoice #"
          prefix={<SearchOutlined />}
          style={{ width: 220 }}
        />
      </Form.Item>
      <Form.Item name="status">
        <Select
          allowClear
          placeholder="Status"
          options={INVOICE_STATUS_OPTIONS}
          style={{ width: 160 }}
        />
      </Form.Item>
      <Form.Item name="paymentMethod">
        <Select
          allowClear
          placeholder="Payment method"
          options={INVOICE_PAYMENT_METHOD_OPTIONS}
          style={{ width: 180 }}
        />
      </Form.Item>
      <Form.Item name="dateRange">
        <RangePicker />
      </Form.Item>
      <Form.Item>
        <Space>
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
          <Button onClick={onReset}>Reset</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default memo(Filters);
